import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Base64 } from 'js-base64';
export default class GenerateLinkPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uid: "",
            type: "USER",
            app: "IKARA",
            song: "",
            duet: "",
            contest: "",
            couple: "",
            deeplink: "",
            loading: false,
            language: "",
            songKeyNames: [],
            contests: [],
            coupleId: "",
            couples: [],
        }
        this.pushNotification = this.pushNotification.bind(this);
        this.displayM = this.displayM.bind(this);
        this.getSingSongs = this.getSingSongs.bind(this);
        this.newGetKey = this.newGetKey.bind(this);
    }
    pushNotification() {
        this.setState({
            loading: true
        });

        if(this.state.type == 'SINGSONGHOT') {
            this.state.uid = this.state.song;
        } else if(this.state.type == 'DUET') {
            this.state.uid = this.state.duet;
        } else if(this.state.type == 'CONTEST') {
            this.state.uid = this.state.contest;
        } else if(this.state.type == 'COUPLE') {
            this.state.uid = 0;
            this.state.coupleId = this.state.couple;
        }

        let json;
        if (this.state.type == 'SINGSONGHOT'){
            if(this.state.app == "IKARA") {
                json = {
                    uid: this.state.uid,
                    domain: window.location.hostname,
                    type: this.state.type,
                    app: this.state.app,
                    // deeplink: this.state.deeplink
                }
            } else {
                json = {
                    youtubeId: this.state.uid,
                    domain: window.location.hostname,
                    type: this.state.type,
                    app: this.state.app,
                    // deeplink: this.state.deeplink
                }
            }
        } else if (this.state.type == 'CONTEST'){
            const filter = this.state.contests.filter(
                item => item._id == this.state.uid);
            json = {
                uid: this.state.uid,
                domain: window.location.hostname,
                type: this.state.type,
                app: this.state.app,
                typeGet: filter.length > 0 ? filter[0].idEvent : "",
            }
        } else if (this.state.type == 'COUPLE'){
            json = {
                uid: 0,
                domain: window.location.hostname,
                type: this.state.type,
                app: this.state.app,
                coupleId: this.state.coupleId,
            }
        } else {
            json = {
                uid: this.state.uid,
                domain: window.location.hostname,
                type: this.state.type,
                app: this.state.app,
                // deeplink: this.state.deeplink
            }
        }

        axios.post(global.config.apiDomain + "/rest/getDeepLink", JSON.stringify(json), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            console.log(res.data);
            this.setState({
                // uid: "",
                // type: "USER",
                // app: "IKARA",
                // song: "",
                // duet: "",
                // contest: "",
                deeplink: res.data
            })

            console.log(res.data)
            this.setState({
                loading: false
            });
        }, err => {
            toast.error("ERR");
        });
    }
    render() {
        const { songKeyNames, type } = this.state;
        return (
            <div id ="content">
                <div className="container p-5">
                    <h2 className="m-3 text-center">Generate Deeplink</h2>
                    {type !== "PRODUCTS" && type !== "ZODIACGAME" && (
                        <div className="input-group mb-3">
                            <input 
                                value={this.state.uid} 
                                onChange={(event) => {
                                    this.setState({
                                        uid: event.target.value
                                    })
                                }}
                                type="text"
                                className="form-control" 
                                placeholder="Nhập uid" />
                        </div>
                    )}
                    <div className="input-group mb-3">
                        <select
                            value={this.state.type}
                            onChange={(event) => {
                                this.setState({
                                    type: event.target.value
                                })
                                this.getSingSongs(this.state.app, event.target.value);
                            }}
                            className="form-control">
                            <option value="USER">USER</option>
                            <option value="LIVEROOM">LIVEROOM</option>
                            <option value="FAMILY">FAMILY</option>
                            <option value="RECORDING">RECORDING</option>
                            <option value="SINGSONGHOT">BÀI ĐANG HOT</option>
                            <option value="DUET">CHỜ SONG CA</option>
                            <option value="CONTEST">CUỘC THI</option>
                            <option value="COUPLE">CẶP ĐÔI</option>
                            <option value="PRODUCTS">THIẾT BỊ</option>
                            <option value="PRODUCT">SẢN PHẨM</option>
                            <option value="ZODIACGAME">GAME LINH VẬT</option>
                        </select>
                    </div>
                    
                    <div className="input-group mb-3">
                        <select
                            value={this.state.app}
                            onChange={(event) => {
                                this.setState({
                                    app: event.target.value
                                });
                                this.state.songKeyNames = [];
                                this.getSingSongs(event.target.value, this.state.type);
                            }}
                            className="form-control">
                            <option value="IKARA">IKARA</option>
                            <option value="YOKARA">YOKARA</option>
                            <option value="OKARA">OKARA</option>
                        </select>
                    </div>
                    {this.displayM() }
                    
                    <div className="">
                        {this.state.loading ?
                            (
                                <button style={{ width: "120px" }} className="btn btn-red float-right" type="button" disabled>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    ...
                                </button>
                            ) :
                            (
                                <button style={{ width: "120px" }} onClick={this.pushNotification} className="btn btn-red float-right" type="button">Push</button>
                            )}
                    </div>
                    <div className="input-group mb-3 text-break">{this.state.deeplink}</div>

                </div>
            </div>
        )
    }

    displayM() {
        const { songKeyNames, app, type, contests, couples } = this.state;
        if(this.state.type == 'SINGSONGHOT') {
            return (
                <div className="input-group mb-3">
                    <select
                        value={this.state.song}
                        onChange={(event) => {
                            this.setState({
                                song: event.target.value,
                                uid: event.target.value
                            })
                        }}
                        className="form-control">
                            <option value=''>Chọn bài hát đang hot</option>
                            {
                                (songKeyNames.map((item) => {
                                    return (
                                      <option key={item.key} value={item.key}>
                                        {item.value}
                                      </option>
                                    );
                                }))
                            }
                    </select>
                </div>
            )
        } else if(this.state.type == 'DUET') {
            return (
                <div className="input-group mb-3">
                    <select
                        value={this.state.duet}
                        onChange={(event) => {
                            this.setState({
                                duet: event.target.value,
                                uid: event.target.value
                            })
                        }}
                        className="form-control">
                        <option value=''>Chọn bài chờ song ca</option>
                        {
                            (songKeyNames.map((item) => {
                                return (
                                    <option key={item.key} value={item.key}>
                                    {item.value}
                                    </option>
                                );
                                }))
                        }
                    </select>
                </div>
            )
        } else if(this.state.type == 'CONTEST') {
            return (
                <div className="input-group mb-3">
                    <select
                        value={this.state.contest}
                        onChange={(event) => {
                            this.setState({
                                contest: event.target.value,
                                uid: event.target.value
                            })
                        }}
                        className="form-control">
                        <option value=''>Chọn cuộc thi</option>
                        {
                            (contests.map((item) => {
                                return (
                                    <option key={item._id} value={item._id}>
                                    {item.name}
                                    </option>
                                );
                                }))
                        }
                    </select>
                </div>
            )
        } else if(this.state.type == 'COUPLE') {
            return (
                <div className="input-group mb-3">
                    <select
                        value={this.state.couple}
                        onChange={(event) => {
                            this.setState({
                                couple: event.target.value,
                                uid: 0,
                                coupleId: event.target.value,
                            })
                        }}
                        className="form-control">
                        <option value=''>Chọn cặp đôi</option>
                        {
                            (couples.map((item) => {
                                return (
                                    <option key={item._id} value={item._id}>
                                    {`${item.user1.name} & ${item.user2.name}`}
                                    </option>
                                );
                                }))
                        }
                    </select>
                </div>
            )
        }
        
    }

    getSingSongs(app, type) {
        let songKeyNameArr = [];
        let songObj = {};
        if(app == 'IKARA') {
            this.state.language = "vi";
        } else if(app == 'YOKARA'){
            this.state.language = "en.yokara";
        } else if(app == 'OKARA'){
            this.state.language = "tl.okara";
        } else {
            return;
        }

        const json = {
            cursor: null,
            language: this.state.language,
            platform: "IOS"
        }

        const jsonBase64 = Base64.encode(JSON.stringify(json));
        var pass = this.newGetKey(jsonBase64, 7123358024, 3564);
        var keys = jsonBase64 + "-" + pass;
        var api = "";
        
        if(type == "SINGSONGHOT") {
            api = "/v33.TopSongs?parameters=";
        } else if(type == "DUET") {
            api = "/v35.TopAsk4DuetRecordings?parameters=";
        } else if(type == "CONTEST") {
            axios.post(global.config.apiDomain + '/rest/theVoiceV2/getListTheVoice')
            .then(res => {
                console.log('/rest/theVoiceV2/getListTheVoice');
                console.log(res);
                if (res.data.status === 'OK') {
                    this.setState({
                        contests: res.data.data
                    })
                } 
            });
            return;
        } else if(type == "COUPLE") {
            axios.post(global.config.apiDomain + '/rest/couple/getListCouple')
            .then(res => {
                console.log('/rest/couple/getListCouple');
                console.log(res);
                if (res.data.status === 'OK') {
                    this.setState({
                        couples: res.data.coupleList
                    })
                } 
            });
            return;
        } else {
            return;
        }
        let url = global.config.apiDomain + api + keys;
        
        axios.post(url, json, {
			headers: {
				'Content-Type': 'application/json'
			}
		}).then(res => {
            if(type == "SINGSONGHOT") {
                if(this.state.app == "IKARA") {
                    res.data.songs.map((item) => {
                        songObj = new Object();
                        songObj.key = item._id;
                        songObj.value = item.songName;
                        songKeyNameArr.push(songObj);
                    });
                } else {
                    res.data.songs.map((item) => {
                        songObj = new Object();
                        songObj.key = item.videoId;
                        songObj.value = item.songName;
                        songKeyNameArr.push(songObj);
                    });
                }
            } else if(type == "DUET") {
                res.data.recordings.map((item) => {
                    songObj = new Object();
                    songObj.key = item._id;
                    songObj.value = item.song.songName;
                    songKeyNameArr.push(songObj);
                    
                });
            }
            this.setState({
                songKeyNames: songKeyNameArr
            });
		}, err => {
            console.log("err:");
			console.log(err);
        });
    }

    newGetKey(data, password, password2) {
        var listOfNumbers = "" + password2;
        for (var i = 0 ; i < data.length; i++) {
            if (data.charAt(i) >= '0' && data.charAt(i) <= '9'){
                listOfNumbers = [listOfNumbers.slice(0, 0), data.charAt(i), listOfNumbers.slice(0)].join('');
            }
        }
        var originalKey = null;
			if (listOfNumbers.length > 15) 
				originalKey = listOfNumbers.substring(0,15);
			else
				originalKey = listOfNumbers;
			return Number(originalKey) + Number(password);
    }
}